import React, { useState } from "react";
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
} from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import ScheduleIcon from "@material-ui/icons/Schedule";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import Archive from "@material-ui/icons/Archive";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import AssignmentIcon from "@material-ui/icons/Assignment";
import CheckListAction from "./Actions/CheckListAction";
import MiembrosTarjeta from "./Actions/MiembrosTarjeta";
import serviciosTablero from "utils/serviciosTablero";
import Etiquetas from "./Actions/Etiquetas";
import Adjunto from "./Actions/Adjunto";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
import Fechas from "./Actions/Fechas";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import Solicitudes from "./Solicitudes";

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  actions: {
    justifyContent: "flex-start", // Alinea los botones a la izquierda
    padding: theme.spacing(1),
  },
}));

const Lista = ({
  onCreateChecklist,
  miembros,
  setMiembros,
  setParticipantesTarjeta,
  tarjeta,
  dataTarjeta,
  setCargando,
  setMensaje,
  infoTablero,
  onDeleteEtiqueta,
  onEtiquetaEdit,
  onEtiquetaChange,
  labels,
  adjunto,
  onFileAdded,
  onCloseModalCard,
  cargarTablero,
  updateData,
  idjerarquia,
  usuario,
  permisos,
  onSolicitudChange,
  onFechaChange,
  tarjetaInfo,
}) => {
  const classesTablero = useStylesTablero();
  const [openDialog, setOpenDialog] = useState(null);
  const classes = useStyles();

  const handleFileAdded = (newFile) => {
    if (typeof onFileAdded === "function") {
      onFileAdded(newFile); // Propagar al componente padre
    }
  };

  const handleEtiquetaChange = (updatedLabels) => {
    // console.log
    if (typeof onEtiquetaChange === "function") {
      onEtiquetaChange(updatedLabels); // Propagar al componente padre
    }
  };
  const handleSolicitudChange = (updatedSolicitud) => {
    // console.log
    if (typeof onSolicitudChange === "function") {
      onSolicitudChange(updatedSolicitud); // Propagar al componente padre
    }
  };
  const handleFechaChange = (updatedfecha, solicitud) => {
    if (typeof onFechaChange === "function") {
      onFechaChange(updatedfecha, solicitud); // Propagar al componente padre
    }
  };
  const handleEtiquetaEliminada = (etiquetaEliminada) => {
    // Propagar el cambio hacia el padre (Tarjeta)
    onDeleteEtiqueta(etiquetaEliminada);
  };
  const handleEtiquetaEdit = (etiquetaEliminada) => {
    // Propagar el cambio hacia el padre (Tarjeta)
    onEtiquetaEdit(etiquetaEliminada);
  };

  const handleClickOpen = (dialog) => {
    setOpenDialog(dialog);
  };

  const handleClose = () => {
    setOpenDialog(null);
  };
  const handleChecklistCreated = (newChecklist) => {
    onCreateChecklist(newChecklist); // Comunica el nuevo checklist al contenedor principal
    handleClose();
  };
  const handleEliminarMiembro = (idusuario) => {
    serviciosTablero.eliminarMiembro(
      (status, mensaje, data) => {
        setMensaje({ open: true, status: status, value: mensaje });
        if (status === 1 && data.miembros) {
          setMiembros(data.miembros);
          setParticipantesTarjeta(data.miembros);

          let nuevaDataTarjeta = {
            ...dataTarjeta,
            participantes: data.miembros,
          };
          updateData("tarjeta", nuevaDataTarjeta, tarjeta);
        }
      },
      setCargando,
      { idusuario, tarjeta }
    );
  };

  const handleArchivar = () => {
    serviciosTablero.archivarTarjeta(
      (status, mensaje, data) => {
        if (status === 1) {
          setMensaje({ open: true, status: status, value: mensaje });
          handleClose();
          onCloseModalCard();
          cargarTablero();
        }
      },
      setCargando,
      { idtarjeta: tarjeta, idestatus: -1 }
    );
  };

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <Button
          variant="contained"
          color="#146C94"
          startIcon={<AssignmentIcon />}
          onClick={() => handleClickOpen("solicitud")}
          fullWidth
          style={{ justifyContent: "flex-start" }}
        >
          SOLICITUDES
        </Button>
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          color="#146C94"
          startIcon={<PersonIcon />}
          onClick={() => handleClickOpen("miembros")}
          fullWidth
          style={{ justifyContent: "flex-start" }}
        >
          Miembros
        </Button>
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          color="#146C94"
          startIcon={<LocalOfferIcon />}
          onClick={() => handleClickOpen("Etiquetas")}
          fullWidth
          style={{ justifyContent: "flex-start" }}
        >
          Etiquetas
        </Button>
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          color="#146C94"
          startIcon={<AttachFileIcon />}
          onClick={() => handleClickOpen("adjunto")}
          fullWidth
          style={{ justifyContent: "flex-start" }}
        >
          Adjunto
        </Button>
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          color="#146C94"
          startIcon={<CheckBoxIcon />}
          onClick={() => handleClickOpen("checklist")}
          fullWidth
          style={{ justifyContent: "flex-start" }}
        >
          CheckList
        </Button>
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          color="#146C94"
          startIcon={<ScheduleIcon />}
          onClick={() => handleClickOpen("fechas")}
          fullWidth
          style={{ justifyContent: "flex-start" }}
          disabled={
            tarjetaInfo?.idsolicitud_fecha || tarjetaInfo?.fecha_entregado === 1
              ? true
              : false
          }
        >
          Fechas
        </Button>
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          color="#146C94"
          style={{ backgroundColor: "#e57373", justifyContent: "flex-start" }}
          startIcon={<Archive />}
          onClick={() => handleClickOpen("archivar")}
          fullWidth
          disabled={!(idjerarquia == 2 || [2, 3].includes(usuario[0]?.idrol))}
        >
          Archivar
        </Button>
      </Grid>

      <Dialog
        open={Boolean(openDialog)}
        onClose={handleClose}
        fullWidth={true}
        maxWidth={"xs"}
      >
        <DialogTitle className={classesTablero.dialogTitle}>
          {(openDialog === "miembros" && "Miembros") ||
            (openDialog === "Etiquetas" && "Etiquetas") ||
            (openDialog === "adjunto" && "Adjunto") ||
            (openDialog === "checklist" && "CheckList") ||
            (openDialog === "fechas" && "Fechas") ||
            (openDialog === "archivar" && "¡ADVERTENCIA!") ||
            (openDialog == "solicitud" && "ASIGNAR SOLICITUD")}
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classesTablero.dialogContent}>
          {openDialog === "miembros" && (
            <div>
              <MiembrosTarjeta
                miembros={miembros}
                onEliminarMiembro={handleEliminarMiembro}
              />
            </div>
          )}
          {openDialog === "Etiquetas" && (
            <div>
              <Etiquetas
                tarjeta={tarjeta}
                setCargando={setCargando}
                setMensaje={setMensaje}
                infoTablero={infoTablero}
                onEtiquetaChange={handleEtiquetaChange}
                onDeleteEtiqueta={handleEtiquetaEliminada}
                onEtiquetaEdit={handleEtiquetaEdit}
              />
            </div>
          )}
          {openDialog === "adjunto" && (
            <Adjunto
              open={openDialog}
              onClose={handleClose}
              tarjeta={tarjeta}
              setCargando={setCargando}
              setMensaje={setMensaje}
              adjunto={adjunto}
              onFileAdded={handleFileAdded}
            />
          )}
          {openDialog === "checklist" && (
            <div>
              <CheckListAction
                open={openDialog}
                onClose={handleClose}
                onCreateChecklist={handleChecklistCreated}
                tarjeta={tarjeta}
                setCargando={setCargando}
              />
            </div>
          )}
          {openDialog === "fechas" && (
            <Fechas
              open={openDialog}
              onClose={handleClose}
              idtarjeta={tarjeta}
              setCargando={setCargando}
              setMensaje={setMensaje}
              onFechaChange={handleFechaChange}
            />
          )}
          {openDialog === "solicitud" && (
            <Solicitudes
              open={openDialog}
              onClose={handleClose}
              tarjeta={tarjeta}
              setCargando={setCargando}
              setMensaje={setMensaje}
              onSolicitudChange={handleSolicitudChange}
              updateData={updateData}
            />
          )}
          {openDialog === "archivar" && (
            <>
              <Typography>
                {
                  "La tarjeta se archivará y ya no se mostrará en el tablero, ¿desea continuar?"
                }
              </Typography>
              <Grid
                container
                justifyContent="flex-end"
                spacing={2}
                style={{ marginTop: "12px" }}
              >
                <Grid item>
                  <Button
                    onClick={handleClose}
                    className={classesTablero.btnCancelar}
                    style={{ margin: "5px 0" }}
                  >
                    CANCELAR
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    onClick={handleArchivar}
                    className={classesTablero.btnEliminar}
                    style={{ margin: "5px 0" }}
                  >
                    ARCHIVAR
                  </Button>
                </Grid>
              </Grid>
            </>
          )}
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default Lista;
